<section class="w3l-form-25">
  <div class="w3l-form-25">
     <BR>
    <label style="width: 250px;">   </label>
    <button type="button" id="Arabic" name="Arabic"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchArabic()">ع </button>
    <button type="button" id="English" name="English"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchEnglish()">En</button>
  </div>
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>{{ 'Accounting Department Data' | translate }}</h1>
          <p>{{'Enter Expenses Details Data' | translate }}</p>
          <h1 style="color: rgb(79, 79, 161);font-weight: bolder;">{{ 'Expenses' | translate }}</h1>
      </div>
</div>
<div id="w3l-appointment">
  <div class="wrapper">
  <div class="d-grid doctor-appointment">
    <form action="#" method="post" >

        <div class="appointment-form-field">
            <label style="width: 150px;">{{ 'Serial' | translate }}</label>
            <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialogSerial()"></span>
            <input type="text" name="expSerial" placeholder="" required="" style="width: 152px;" [(ngModel)]="trserial" (change)="retriveexpenses()">
        </div>
        <!-- Date/  Document Kind -->
        <div class="appointment-form-field">
          <label style="width: 150px;">{{ 'Date' | translate }}</label>
            <input type="date" name="expdate"  required="" style="width: 200px;" [(ngModel)]="trdate">

            <label style="width: 75px;"></label>

            <label style="width: 75px;">{{ 'Kind' | translate }}</label>

          <select id="kind" name="trkind" style="width: 200px;;background-color:  rgb(187, 203, 238);" [(ngModel)]= "trkind" [value]="trkind" (change)="ShowChequeInfo()" required>
              <option value="1">Cash/نقدا</option>
              <option value="2">Cheque/شيك</option>
              <option value="3">Adjustment/تسوية</option>
              <option value="4">Credit Cards/كارت ائتمان</option>
              <option value="5">Taxes/تسوية ضرائب</option>

          </select>
        </div>
            <!-- Cheque Info. -->
        <div *ngIf= "!wk_Cheque" class="appointment-form-field">
          <label style="width: 150px;">{{ 'Due Date' | translate }}</label>
            <input type="date" name="duedate"  required="" style="width: 200px;" [(ngModel)]="trchduedate">

            <label style="width: 75px;"></label>

            <label style="width: 75px;">{{ 'Cheque No.' | translate }}</label>
            <input type="text" name="chequeNo" maxlength="20ch" required="" style="width: 200px;" [(ngModel)]="trchno">


        </div>
          <!-- Supplier -->
            <div class="appointment-form-field">
            <label style="width: 150px;">{{ 'Supplier' | translate }}</label>
            <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialogSupplier()"></span>
            <input type="text" name="expSupplier" maxlength="50ch"  placeholder="" required="" style="width: 150px;" [(ngModel)]="trcln_supp" (change)="retrivesupplier()">
            <input type="text" name="expname" disabled="true" required="" style="width: 352px; "   [(ngModel)]="trcln_supp_Name">
             </div>
          <!-- Value/ Currency -->
            <div class="appointment-form-field">
            <label style="width: 150px;">{{ 'Value' | translate }}</label>
              <input type="number" name="expvalue"  placeholder="00.00" required="00.00"  style="width: 200px;" [(ngModel)]="trvalue">

              <label style="width: 75px;"></label>

              <label style="width: 75px;">{{ 'Currency' | translate }}</label>

              <select id="kind" name="trkind" style="width: 110px;;background-color:  rgb(187, 203, 238);" [(ngModel)]= "trcurrency" [value]="trcurrency" required>
                <option value="1">LE</option>
                <option value="2">USD</option>
                <option value="3">Uoro</option>
              </select>
              <input type="number" min="1" name="trrate" style="width: 90px;" step="0.01" [(ngModel)]="trrate">

            </div>
              <!-- Doctor -->
              <div class="appointment-form-field">
                <label style="width: 150px;">{{ 'Doctor' | translate }}</label>
                <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialogDoctor()"></span>
                <input type="text" name="expdoctor" placeholder="" required="" style="width: 150px;" [(ngModel)]="trdoctor" (change)="retrivedoctors()">
                <input type="text" name="expdoctorname" disabled="true" required="" style="width: 352px; "   [(ngModel)]="trdoctor_Name">
                 </div>
          <!-- Expensses type -->
            <div class="appointment-form-field">
              <label style="width: 150px;">{{ 'Expenses Type' | translate }}</label>
              <select id="kind" name="trexpensses" style="width: 550px;;background-color:  rgb(187, 203, 238);" [(ngModel)]= "trclass" [value]="trclass" required>
                <option value="{{cls.expcode}}" *ngFor="let cls of expenssesList; let i = index">{{cls.expname}}</option>
            </select>
          </div>
            <!-- Bank -->
            <div class="appointment-form-field">
              <label style="width: 150px;">{{ 'Bank/Treasury' | translate }}</label>
              <select id="kind" name="trbank" style="width: 550px;;background-color:  rgb(187, 203, 238);" [(ngModel)]= "trbank" [value]="trbank" required>
                <option value="{{cls.bnkcode}}" *ngFor="let cls of bankList; let i = index">{{cls.bnkname}}</option>
            </select>


            </div>

               <!-- Hospital -->
            <div class="appointment-form-field">
              <label style="width: 150px;">{{ 'Hospital' | translate }}</label>

              <select id="kind" name="trhospital" style="width: 550px;;background-color:  rgb(187, 203, 238);" [(ngModel)]= "trhospital" [value]="trhospital" required>
                <option value="{{cls.hoscode}}" *ngFor="let cls of hospitalList; let i = index">{{cls.hosname}}</option>


            </select>
          </div>
            <!-- Notes -->
            <div class="appointment-form-field">
              <label style="width: 150px;">{{ 'Notes' | translate }}</label>
              <input type="text" name="expnotes" maxlength="150ch" required="" style="width: 550px;"   [(ngModel)]="trdescription">
            </div>
            <!-- Buttens -->
            <BR>
            <div class="appointment-form-field">
              <label style="width: 150px;"></label>
              <button type="button" class="theme-button btn" style="width: 20%;font-weight: bold;" name="submit" (click)="submitPayments()">{{ 'Submit' | translate }}</button>
              <button type="button" class="theme-button btn" style="width: 20%;font-weight: bold;" name="Delete" (click)="mesgDelete()">{{ 'Delete' | translate }}</button>
              <button type="button" class="theme-button btn" style="width: 20%;font-weight: bold;" name="New" (click)="NewData()">{{ 'New' | translate }}</button>
              <button type="button" class="theme-button btn" style="width: 20%;font-weight: bold;" name="print"(click)="ReportPayment()">{{ 'Print' | translate }}</button>
              <a href="Home">
              <button type="button" class="theme-button btn" style="width: 20%;font-weight: bold;" name="Back">{{ 'Home' | translate }}</button>
              </a>
            </div>
            <BR>
              <BR>

    </form>
  </div>
  </div>

</div>
</section>
